export const unOrderListData = [
    'One who looks on the bright side of things',
    'One who does something not professionally but for pleasure',
    'A person who knows everything',
    'A handwriting that cannot be read',
    'One who looks on the bright side of things',
    'A sound that cannot be heard',
    'The study of ancient writing and scriptures',
    'The study of rocks and soil',
    'creates more sophisticated capabilities for a web page to use coding language.',
    'Maintaining contact and communicating clearly are also essential. possess abilities for a designer'
]

export const textColorData = [
    {
        class: 'txt-secondary mb-0',
        text: 'This is Secondary text You can archive this adding',
        code: '.txt-secondary'
    },
    {
        class: 'txt-success mb-0',
        text: 'This is Success text You can archive this adding',
        code: '.txt-success'
    },
    {
        class: 'txt-info mb-0',
        text: 'This is Info text You can archive this adding',
        code: '.txt-info'
    },
    {
        class: 'txt-warning mb-0',
        text: 'This is Warning text You can archive this adding',
        code: '.txt-warning'
    },
    {
        class: 'txt-danger mb-0',
        text: 'This is Danger text You can archive this adding',
        code: '.txt-danger'
    },
    {
        class: 'txt-dark mb-0',
        text: 'This is Dark text You can archive this adding',
        code: '.txt-dark'
    },
    {
        class: 'txt-primary mb-0',
        text: 'This is Primary text You can archive this adding',
        code: '.txt-primary'
    }
]

export const blockQuotesData = [
    {
        class: 'figure text-center d-block dark-blockquote',
        text: 'In this life we cannot do great things. We can only do small things with great love.',
        footer: 'Mother Teresa'
    },
    {
        class: 'figure text-end d-block dark-blockquote',
        text: 'Live in the sunshine, swim the sea, drink the wild air.',
        footer: 'Ralph Waldo Emerson'
    }
]